
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-scores/[...matchSlug]",
      function () {
        return require("private-next-pages/live-scores/[...matchSlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-scores/[...matchSlug]"])
      });
    }
  